import { render, staticRenderFns } from "./FinishLogin.vue?vue&type=template&id=4f6c7870"
import script from "./FinishLogin.vue?vue&type=script&lang=ts"
export * from "./FinishLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports